// The day object every lens shares (DEC-024).

/**
 * The day object in the shape the prototype lenses were written against: lookup tables,
 * a ranked list, each area's z, and the old field names (brain.mni, atlas, cats) mapped
 * from the pack's neutral ones (region.coords, chart, categories). Returns a deep copy.
 */
export function legacyDay(payload) {
  const d = structuredClone(payload);
  d.papers = d.papers || [];
  d.goals = d.goals || [];
  d.areas = (d.areas || []).map(a => ({
    ...a,
    brain: a.brain || { region: a.region?.region || "", mni: a.region?.coords || [0, 0, 0], why: a.region?.why || "", ba: "" },
    atlas: a.atlas || a.chart,
    cats: a.cats || a.categories || [],
  }));
  d.areaById = Object.fromEntries(d.areas.map(a => [a.id, a]));
  d.paperById = Object.fromEntries(d.papers.map(p => [p.id, p]));
  d.goalById = Object.fromEntries(d.goals.map(g => [g.id, g]));
  for (const a of d.areas) a.z = +((a.today - a.mean) / (a.sd || 1)).toFixed(2);
  d.ranked = d.papers.slice().sort((a, b) => b.salience - a.salience);
  return d;
}
